import { LabourOperationsState } from './labour-operations.interfaces';
import { initialState } from './service-groups/service-groups.interfaces';
import { initialState as serviceInitialState } from './services/services.interfaces';
import { initialState as ratesInititalState } from './service-group-rates/service-group-rate.interfaces';
import { initialState as declinedReasonsInitialState } from './declined-reasons/declined-reasons.interfaces';
export const labourOperationsInitialState: LabourOperationsState = {
  serviceGroups: initialState,
  services: serviceInitialState,
  rates: ratesInititalState,
  declinedReasons: declinedReasonsInitialState
};
